<form
  action=""
  (ngSubmit)="updateResidence()"
  [formGroup]="residenceForm"
  eevTrackFormStart
  [eevFormTrackingConfig]="residenceFormTrackingConfig"
  >
  <div class="dropdown-container">
    <app-be-select-reactive
      [beFormGroup]="residenceForm"
      [beFormControl]="residenceForm.controls['ownershipStatusId']"
      beFormControlName="ownershipStatusId"
      label="Ownership Status"
      [options]="ownershipStatuses"
      optionKey="label"
      [eevTrackingConfig]="
        residenceFormTrackingConfig.fields[
          AuthFormFieldName.RESIDENCE_OWNERSHIP_STATUS
        ]
      "
    ></app-be-select-reactive>
  </div>

  <app-be-input-group-reactive
    [beFormGroup]="residenceForm"
    [beFormControl]="residenceForm.controls['monthlyPayment']"
    beFormControlName="monthlyPayment"
    inputLabel="Monthly Payment"
    maskValue="separator"
    [eevTrackingConfig]="
      residenceFormTrackingConfig.fields[
        AuthFormFieldName.RESIDENCE_MONTHLY_PAYMENT
      ]
    "
    >
    <svg icon viewBox="0 0 100 100" class="be-input-icon be-input-icon--left">
      <use [attr.href]="'assets/icons-v2/sprites.svg#dollar-sign'"></use>
    </svg>
  </app-be-input-group-reactive>
  <div class="be-section-mt--responsive be-btn-group be-btn-group--left">
    <app-be-button
      size="small"
      type="submit"
      id="saveResidenceFormBtn"
      [isDisabled]="residenceForm.invalid"
      [eevTrackClick]="AuthLinkType.PROFILE_SAVE"
      >
      Save
    </app-be-button>
    @if (residenceData) {
      <button
        (click)="onCancel.emit()"
        class="be-btn be-btn--small be-btn--alt-borderless"
        type="button"
        [eevTrackClick]="AuthLinkType.PROFILE_CANCEL_EDIT"
        >
        Cancel
      </button>
    }
  </div>
</form>
